import { useLang } from '@/i18n';
import css from './index.module.scss';
import { useEffect, useState } from 'react';
import gtm from '@/utils/gtm';

const A3: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    const [isM, setIsM] = useState<boolean>(false);

    useEffect(() => {
        setIsM(window.innerWidth < 1024);
    }, []);

    const handleScrollTo = (id: string, className: string) => {
        // 滚动到元素上面100px
        const element = document.querySelector(id);

        if (element) {
            const elementRect = element.getBoundingClientRect();
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetScrollTop = elementRect.top + currentScrollTop - 100;

            window.scrollTo({
                top: targetScrollTop,
                behavior: 'smooth',
            });
        }

        gtm.push({
            __btn_id1: className,
            __btn_id2: className,
            __btn_type: 'common',
        });
    };

    return (
        <section
            className={`${css.section} stream-ultra-x-A GtmModuleData-section`}
            id="stream-ultra-x-A"
            data-section-id={'stream-ultra-x-A'}
            data-section-title={t('A_title_de')}
        >
            <div className="img">
                <picture>
                    <source media="(min-width: 1024px)" srcSet={'https://websiteoss.ecoflow.com/upload/image/1760321598600/pc.webp'} type="image/webp" />
                    <source media="(min-width: 1024px)" srcSet={'https://websiteoss.ecoflow.com/upload/image/1760321598813/pc.jpg'} type="image/jpg" />
                    <source srcSet={'https://websiteoss.ecoflow.com/upload/image/1760321598016/h5.webp'} type="image/webp" />
                    <img
                        fetchPriority="high"
                        src={'https://websiteoss.ecoflow.com/upload/image/1760321599364/h5.jpg'}
                        alt={t('A_title_de')}
                        width="100%"
                        height="100%"
                    />
                </picture>
            </div>
            <div className="info">
                <h2 className="title">{t('A_title_de')}</h2>
                <p className="desc">{t('A_desc_de')}</p>
                <div className="group-btn">
                    <a
                        className="shopNow A3-shop-now GtmModuleData-btn-common"
                        data-btn-id="A3-shop-now"
                        onClick={() => handleScrollTo('#stream-ultra-x-C', 'A3-shop-now')}
                    >
                        {t('A3_shop_now')}
                    </a>
                    <a
                        className="learnMore A3-learn-more GtmModuleData-btn-common"
                        data-btn-id="A3-learn-more"
                        onClick={() => handleScrollTo('#learnMore', 'A3-learn-more')}
                    >
                        {t('A3_learn_more')}
                    </a>
                </div>
            </div>
        </section>
    );
};

export default A3;
